module.exports = __webpack_public_path__ + "static/media/rott.335701a6.jpg";